(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var ListView = require('./views/list')
  , FormView = require('./views/form')
  , RoleCollection = require('./collections/role')
  , RoleModel = require('./models/role')
  , debug = require('../lib/debug')('router')

module.exports = function (serviceLocator) {
  var router = serviceLocator.router
    , collection = new RoleCollection()
    , displayName = { singular: 'Role', plural: 'Roles' }

  router.route('roles(/)', 'listRoles', function () {
    debug('roles list view route triggered')
    if (!serviceLocator.allow('role', 'update')) {
      return false
    }
    var listView = new ListView(
      { collection: collection
      , serviceLocator: serviceLocator
      , displayName: displayName })

    listView.on('new', router.navigate.bind(router, 'roles/form'
      , { trigger: true }))

    listView.on('edit', function (model) {
      router.navigate('roles/' + model.id + '/form', { trigger: true })
    })
    router.render(listView, 'Roles')
    collection.reset()
    collection.fetch({ update: true })
  })

  router.route('roles/form(/)', 'newRoles', function () {
    debug('role create view route triggered')
    if (!serviceLocator.allow('role', 'create')) {
      return false
    }
    var model = new RoleModel({}, { collection: collection })
      , view = new FormView(
        { title: displayName.singular
        , model: model
        , serviceLocator: serviceLocator
        }
       )
    collection.reset()
    collection.fetch({ update: true })

    view.on('save', function (viewModel) {
      var rootRole = collection.filter(function (role) {
        return role.attributes.name === 'root'
      })[0]

      var rootAdminGrants = rootRole.get('grants')
      rootAdminGrants.administrator.push(viewModel.get('permissionName'))

      rootRole.set('grants', rootAdminGrants)
      rootRole.save()
      collection.set(rootRole, { remove: false })

      router.navigate('roles', { trigger: true })
    })

    view.on('cancel', function () {
      router.navigate('roles', { trigger: true })
    })

    router.render(view, 'Roles')
  })

  router.route('roles/:id/form(/)', 'editRoles', function (id) {
    debug('role edit view route triggered')
    if (!serviceLocator.allow('role', 'update')) {
      return false
    }

    collection.retrieve(id, function (err, model) {
      if (err) {
        router.trigger('notFound', err.message)
        return
      }

      var view = new FormView(
        { title: displayName.singular
        , model: model
        , serviceLocator: serviceLocator
        }
      )

      view.on('cancel', function () {
        router.navigate('roles', { trigger: true })
      })

      router.render(view, displayName.plural)
    })
  })

}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/role/routes.js","/admin/source/js/app/role")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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